import React, { Component } from 'react';
import Layout from '../../Layout/layout';
import Helmet from 'react-helmet';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { apiHost } from '../../api/apiClient';
import {setLoadingPage,setErrorMessage} from '../../reducers/actions';
import { connect } from 'react-redux';
import EventTable from './eventTable';
import '../../styles/events/events.scss';

class Events extends Component {
    constructor(props){
        super(props);
        this.state={
            eventList:[]
        }
    }
    componentDidMount(){
let urlEvents= `${apiHost}/api/Event/AllEvents`;
this.getEvents(urlEvents);
    }

    getEvents=async(url)=>{
        this.props.setLoadingPageAction(true);
        try {
            let EventsList = await axios.get(url, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            });
            console.log("events", EventsList);
            this.setState({
                eventList: EventsList.data
           
            });
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
             }else{
                this.props.setErrorMessageAction(`${e}`)
   
              }
          this.props.setLoadingPageAction(false);
        
            console.log(`😱 Axios request failed: ${e}`);
          

    }
}
handleCreateNew=()=>{
    this.props.history.push('/create-new-event');
}

    render() {
        return (
            <Layout>
            
<Helmet>
    <title>Events</title>
</Helmet>
            <div className="contentBody">
                <div className="contentWrapper">
<h2>Index</h2>
<Button variant="primary" onClick={()=>{this.handleCreateNew()}} >Create New</Button>

                <div className="eventsTable">
              <EventTable EventsList={this.state.eventList} />
              
                </div>
            </div>
            </div>
            </Layout>
        );
    }
}


const mapStateToProps= (state)=>({

    loading:state.loading
    
  })
  const mapDispatchToProps= {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction:setErrorMessage
  
    
  }
  
  export default connect(mapStateToProps,mapDispatchToProps)(Events);